import { useQuery } from "react-query";
import { fetchServer } from "../utils";

export interface RestyleOption {
  id: string;
  name: string;
  prompt: string;
}

export const useRestyleOptions = () => {
  const options = useQuery(["restyle-options"], async () => {
    return await fetchServer<RestyleOption[]>("/api/images/restyle-options");
  });

  return {
    options,
    refresh: () => options.refetch(),
  };
};
